<div class="n-filtro-wrapper">
  <!-- Serviços -->
  <div class="n-filtro-field">
    <div class="n-filtro-label">
      <i class="pi pi-wrench"></i>
      {{ $nicho().servico.plural | uppercase }}
    </div>
    @if (deviceService.$isMobile()) {
    <lib-n-multiselect
      class="w-full"
      [placeholder]="$nicho().servico.placeholderSelecione"
      [options]="servicosFlat()"
      optionLabel="label"
      optionValue="value"
      [maxSelectedLabels]="2"
      [selectedItemsLabel]="'BARDO_AGENDA.ITENS_SELECIONADOS' | translate"
      [ngModel]="servicosSelecionados"
      (ngModelChange)="servicosSelecionados = $event; onServicosChange()"
      [showHeader]="true"
    />
    } @else {
    <p-multiSelect
      class="w-full"
      appendTo="body"
      scrollHeight="600px"
      display="chip"
      [placeholder]="$nicho().servico.placeholderSelecione"
      [emptyMessage]="'BARDO_AGENDA.NENHUM_RESULTADO' | translate"
      [selectedItemsLabel]="'BARDO_AGENDA.ITENS_SELECIONADOS' | translate"
      [emptyFilterMessage]="'BARDO_AGENDA.NENHUM_RESULTADO' | translate"
      [options]="agendaFiltroService.grupoServicos()"
      [group]="true"
      [maxSelectedLabels]="2"
      [(ngModel)]="servicosSelecionados"
      (onChange)="onServicosChange()"
    >
      <ng-template pTemplate="dropdownicon">
        <i class="pi pi-wrench"></i>
      </ng-template>
    </p-multiSelect>
    }
  </div>

  <!-- Profissionais -->
  <div class="n-filtro-field">
    <div class="n-filtro-label">
      <i class="pi pi-users"></i>
      {{ $nicho().profissional.plural | uppercase }}
    </div>
    @if (deviceService.$isMobile()) {
    <lib-n-multiselect
      class="w-full"
      [placeholder]="$nicho().profissional.placeholderSelecione"
      [options]="agendaFiltroService.profissionais()"
      optionLabel="nome"
      optionValue="id"
      [maxSelectedLabels]="2"
      [selectedItemsLabel]="'BARDO_AGENDA.ITENS_SELECIONADOS' | translate"
      [ngModel]="profissionaisSelecionados"
      (ngModelChange)="
        profissionaisSelecionados = $event; onProfissionaisChange()
      "
      [showHeader]="true"
    />
    } @else {
    <p-multiSelect
      appendTo="body"
      class="w-full"
      [placeholder]="$nicho().profissional.placeholderSelecione"
      optionLabel="nome"
      optionValue="id"
      display="chip"
      [emptyMessage]="'BARDO_AGENDA.NENHUM_RESULTADO' | translate"
      [selectedItemsLabel]="'BARDO_AGENDA.ITENS_SELECIONADOS' | translate"
      [emptyFilterMessage]="'BARDO_AGENDA.NENHUM_RESULTADO' | translate"
      [options]="agendaFiltroService.profissionais()"
      [maxSelectedLabels]="2"
      [(ngModel)]="profissionaisSelecionados"
      (onChange)="onProfissionaisChange()"
    >
      <ng-template pTemplate="dropdownicon">
        <i class="pi pi-users"></i>
      </ng-template>
    </p-multiSelect>
    }
  </div>

  <!-- Status -->
  <div class="n-filtro-field">
    <div class="n-filtro-label">
      <i class="pi pi-circle-fill"></i>
      {{ 'BARDO_AGENDA.FILTRAR_STATUS' | translate | uppercase }}
    </div>
    <div class="n-status-grid">
      @for (filtro of agendaFiltroService.filtrosDisponiveis; track filtro.nome)
      {
      <div
        class="filtro-item"
        [class.ativo]="
          agendaFiltroService.filtrosAtivos().includes(filtro.nome)
        "
        role="checkbox"
        [attr.aria-checked]="
          agendaFiltroService.filtrosAtivos().includes(filtro.nome)
        "
        tabindex="0"
        (click)="alternarFiltro(filtro.nome)"
        (keyup.enter)="alternarFiltro(filtro.nome)"
      >
        <div class="n-status" [ngClass]="filtro.cor"></div>
        <span class="n-text-status">{{ filtro.chaveTraducao | translate }}</span>
        @if (agendaFiltroService.filtrosAtivos().includes(filtro.nome)) {
        <i class="pi pi-check n-status-check"></i>
        }
      </div>
      }

      <div
        class="filtro-item"
        [class.ativo]="agendaFiltroService.filtroEncaixeAtivo()"
        role="checkbox"
        [attr.aria-checked]="agendaFiltroService.filtroEncaixeAtivo()"
        tabindex="0"
        (click)="agendaFiltroService.alternarFiltroEncaixe()"
        (keyup.enter)="agendaFiltroService.alternarFiltroEncaixe()"
      >
        <i class="pi pi-bolt n-status-icon encaixe"></i>
        <span class="n-text-status">{{ 'BARDO_AGENDA.ENCAIXE' | translate }}</span>
        @if (agendaFiltroService.filtroEncaixeAtivo()) {
        <i class="pi pi-check n-status-check"></i>
        }
      </div>
    </div>
  </div>

  <!-- Rodapé -->
  <div class="n-filtro-footer">
    <p-button
      type="button"
      severity="secondary"
      [text]="true"
      icon="pi pi-filter-slash"
      [label]="'BARDO_AGENDA.LIMPAR_FILTROS' | translate"
      styleClass="w-full"
      (onClick)="limparFiltros()"
    />
  </div>
</div>
